import React from "react";
import { StarIcon } from "lucide-react";
import { testimonials } from "../data/testimonials";
import { SectionCTA } from "./SectionCTA";
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-287" data-mp="20t9xjvsjp99z">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-[#F5B301] text-[#F5B301]" aria-hidden="true" data-id="element-288" data-mp="1r1dwcbv5x31j" data-mpi={i} />)}
    </div>;
}
export function TestimonialsSection() {
  return <section className="bg-canvas px-4 py-16 md:py-24" data-id="element-289" data-mp="1d47eqkm6dadw">
      <div className="mx-auto max-w-5xl" data-id="element-290" data-mp="1i1z8lk6dr6kq">
        <div className="text-center" data-id="element-291" data-mp="1hyl3i46c0j9l">
          <h2 className="font-serif text-[30px] font-extrabold leading-tight text-ink md:text-5xl" data-id="element-292" data-mp="141y5rz6k1p2m">
            What other dental professionals <em className="text-brand" data-id="element-293" data-mp="1839vs5tcccbc">are saying</em>
          </h2>
          <div className="mt-4 inline-flex items-center gap-3 rounded-full bg-white px-4 py-2 ring-1 ring-navy-900/10" data-id="element-294" data-mp="2yexs0b5fxhiv">
            <Stars data-id="element-295" data-mp="32fhkh1f2jwyo" />
            <span className="text-base font-extrabold text-ink" data-id="element-296" data-mp="32eopexph2vwd">4.9/5</span>
          </div>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-297" data-mp="2uzhqv94o8wc9">
          {testimonials.map((t, i) => <figure key={t.name} className={`flex flex-col rounded-3xl bg-white p-6 ring-1 ring-navy-900/10 ${i === 0 ? "md:col-span-2 lg:col-span-1 lg:row-span-1" : ""}`} data-id="element-298" data-mp="34re1tkruwgxw" data-mpi={i}>
              <Stars data-id="element-299" data-mp="2c2go7uylb8bh" />
              <blockquote className="mt-4 text-[17px] font-medium leading-relaxed text-ink" data-id="element-300" data-mp="2c3rohksttxxu">“{t.quote}”</blockquote>
              <figcaption className="mt-auto flex items-center gap-3 pt-6" data-id="element-301" data-mp="2756mpgxxf67a">
                <img src={t.image} alt={t.name} className="h-14 w-14 shrink-0 rounded-full object-cover ring-2 ring-brand-light" loading="lazy" data-id="element-302" data-mp="2m161fafjk4le" />
                <div data-id="element-303" data-mp="2h3w8hksy1ast">
                  <p className="font-bold text-ink" data-id="element-304" data-mp="1aniy5b6e9es">{t.name}</p>
                  <p className="text-sm text-muted" data-id="element-305" data-mp="18u96h59n92k">{t.location}</p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <SectionCTA label="I want the same clarity in my cases" data-id="element-306" data-mp="3fk2a8dhp4w9" />
      </div>
    </section>;
}